import React from "react";
import { ReactComponent as LeftTri } from "images/background/what-sets-us-apart-left-triangle.svg";
import { ReactComponent as RightBlue } from "images/background/what-sets-us-apart-right-triangle-blue.svg";
import { ReactComponent as RightRed } from "images/background/what-sets-us-apart-right-triangle-red.svg";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const goopterBenefit = [
  {
    id: "goopterBenefit1",
    message: <FormattedMessage id={"what_sets_sec_goopter_bene1"} />,
  },
  {
    id: "goopterBenefit2",
    message: <FormattedMessage id={"what_sets_sec_goopter_bene2"} />,
  },
  {
    id: "goopterBenefit3",
    message: <FormattedMessage id={"what_sets_sec_goopter_bene3"} />,
  },
  {
    id: "goopterBenefit4",
    message: <FormattedMessage id={"what_sets_sec_goopter_bene4"} />,
  },
  {
    id: "goopterBenefit5",
    message: <FormattedMessage id={"what_sets_sec_goopter_bene5"} />,
  },
  {
    id: "goopterBenefit6",
    message: <FormattedMessage id={"what_sets_sec_goopter_bene6"} />,
  },
];
const thirdPartyDownside = {
  list1: [
    {
      id: "thirdPartyDownside1",
      message: <FormattedMessage id={"what_sets_sec_third_list1"} />,
    },
    {
      id: "thirdPartyDownside2",
      message: <FormattedMessage id={"what_sets_sec_third_list2"} />,
    },
    {
      id: "thirdPartyDownside3",
      message: <FormattedMessage id={"what_sets_sec_third_list3"} />,
    },
    {
      id: "thirdPartyDownside4",
      message: <FormattedMessage id={"what_sets_sec_third_list4"} />,
    },
    {
      id: "thirdPartyDownside5",
      message: <FormattedMessage id={"what_sets_sec_third_list5"} />,
    },
    {
      id: "thirdPartyDownside6",
      message: <FormattedMessage id={"what_sets_sec_third_list6"} />,
    },
  ],
  list2: [
    {
      id: "thirdPartyDownside7",
      message: <FormattedMessage id={"what_sets_sec_third_list7"} />,
    },
    {
      id: "thirdPartyDownside8",
      message: <FormattedMessage id={"what_sets_sec_third_list8"} />,
    },
  ],
};

export default function WhatsSets() {
  return (
    <section className="whatSets">
      <div className="bg">
        <div className="bg-left">
          <LeftTri className="bg-img-left" />
        </div>
        <div className="bg-right">
          <RightBlue className="bg-img-right1" />
          <RightRed className="bg-img-right2" />
        </div>
      </div>
      <div className="header">
        <h2>
          <FormattedMessage id={"what_sets_sec_header_title"} />
        </h2>
        <p>
          <FormattedMessage id={"what_sets_sec_header_desc"} />
        </p>
        <p className="accent">
          <FormattedMessage id={"what_sets_sec_header_desc2"} />
          <span className="gray">| </span>
          <FormattedMessage id={"what_sets_sec_header_desc3"} />
          <span className="gray">| </span>
          <FormattedMessage id={"what_sets_sec_header_desc4"} />
        </p>
      </div>
      <div className="contents container row mx-auto">
        <div className="col-lg-6 col-sm-12">
          <div className="container">
            <h3 className="primary">
              <FormattedMessage id={"goopter"} />
            </h3>
            <p>
              <FormattedMessage id={"what_sets_sec_goopter_desc"} />
            </p>
            <ul>
              {goopterBenefit.map(item => (
                <li key={item.id}>{item.message}</li>
              ))}
            </ul>
            <div className="buttons">
              <div className="btn green-button">
                <Link to="/features-business" className="text-white">
                  <FormattedMessage id={"view_all_features"} />
                </Link>
              </div>
              <Link to="/pricing" className="primary">
                <FormattedMessage id={"view_pricing_options"} />
              </Link>
            </div>
            <p className="weaker">
              <FormattedMessage id={"what_sets_sec_goopter_including"} />
            </p>
          </div>
        </div>
        <hr className="divider" />
        <div className="col-lg-6 col-sm-12 right-box">
          <div className="">
            <h3>
              {" "}
              <FormattedMessage id={"what_sets_sec_third_subtitle"} />
            </h3>
            <ul className="weaker">
              {thirdPartyDownside.list1.map(item => (
                <li key={item.id}>{item.message}</li>
              ))}
            </ul>
            <ul className="weaker">
              <FormattedMessage id={"on_top_of_that"} />
              {thirdPartyDownside.list2.map(item => (
                <li key={item.id}>{item.message}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
